import { render } from "./practice-main.html?vue&type=template&id=fc7b6444&scoped=true&ts=true&external"
import script from "./practice-main.ts?vue&type=script&lang=ts&external"
export * from "./practice-main.ts?vue&type=script&lang=ts&external"

import "./practice-main.scss?vue&type=style&index=0&id=fc7b6444&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7b6444"]])

export default __exports__